module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/blog/sample-news/sample-news.component.scss
// module id = 751
// module chunks = 0